import { render, staticRenderFns } from "./NeedsQuestionnaire.vue?vue&type=template&id=6effaf0e&scoped=true&"
import script from "./NeedsQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./NeedsQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./NeedsQuestionnaire.vue?vue&type=style&index=0&id=6effaf0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6effaf0e",
  null
  
)

export default component.exports